<div class="en" *ngIf="localService.languageContent != null && localService.languageContent.common != undefined">
  <div style="width:65px;float:left;" *ngIf="selectedHour != ''">
    <ngx-select [optionValueField]="'value'" [disabled]="isDisabled"
      title="{{localService.languageContent.common.hours}}" [optionTextField]="'value'" [items]="hours"
      [(ngModel)]="selectedHour" (select)="onEmitValue()">
    </ngx-select>
  </div>
  <span style="float:left;">&nbsp;:&nbsp;</span>
  <div style="width:65px;float:left;" *ngIf="selectedMinute != ''">
    <ngx-select [optionValueField]="'value'" [disabled]="isDisabled"
      title="{{localService.languageContent.common.minutes}}" [optionTextField]="'value'" [items]="minutes"
      [(ngModel)]="selectedMinute" (select)="onEmitValue()">
    </ngx-select>
  </div>
  <div style="float: left;margin-left: 15px;margin-top: 2px;" class="{{localService.selectedLanguageCode}}">
    <label style="font-weight: normal; margin-left: 10px;">
      <input type="radio" name="meridium_{{id}}" [checked]="isAm" (click)="onClick(1)" [disabled]="isDisabled" />
      <span class="normal_color">{{localService.languageContent.common.am}}</span>
    </label>
    <label style="font-weight: normal; margin-left: 20px;">
      <input type="radio" name="meridium_{{id}}" [checked]="!isAm" (click)="onClick(2)" [disabled]="isDisabled" />
      <span class="normal_color">{{localService.languageContent.common.pm}}</span>
    </label>
  </div>
</div>